import React, {
  useState,
  useEffect,
  useLayoutEffect,
  useRef,
  useMemo,
  useCallback,
} from "react";

import { components } from "react-select";
import {
  Row,
  Col,
  Card,
  Form,
  Button,
  Modal,
  CardBody,
  Container,
} from "react-bootstrap";
import Select from "react-select";
import { Line, Pie } from "react-chartjs-2";
import {
  Chart as ChartJS,
  ArcElement,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
  Title,
} from "chart.js";

import { useDispatch, useSelector } from "react-redux";
import { sharedComparison } from "../../../redux/slices/cityComparisonSlice";
import { useParams } from "react-router-dom";
import { QRCodeCanvas } from "qrcode.react";

import "./city-comparision.scss";

ChartJS.register(
  ArcElement,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
  Title,
);
// const StarIcon = () => <FiStar />;

const CityComparison = ({ onClose }) => {
  const { token } = useParams();
  const dispatch = useDispatch();
  const scrollRef = useRef(null);
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(false);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);
  const handleMouseLeave = () => setIsDragging(false);
  const handleMouseUp = () => setIsDragging(false);
  const { sharedComparisonItems, isLoading, isError } = useSelector(
    (state) => state.cityComparison,
  );
  const citiesData = useMemo(() => {
    try {
      const raw = sharedComparisonItems?.data?.data?.cities;

      return typeof raw === "string" ? JSON.parse(raw) : raw ?? {};
    } catch (e) {
      console.error("Invalid JSON in cities:", e);
      return {};
    }
  }, [sharedComparisonItems?.data?.data?.cities]);

  const homeCity = citiesData?.home_city || null;
  // const compareCities = citiesData?.compare || [];
  const compareCities = useMemo(() => {
    return citiesData?.compare ?? [];
  }, [citiesData]);
  const [isBelow1280, setIsBelow1280] = useState(window.innerWidth <= 1280);
  const compareCount = compareCities.length;

  const referralCode = useMemo(() => {
    try {
      const rawHomeCity = citiesData?.home_city;

      const homeCity =
        typeof rawHomeCity === "string"
          ? JSON.parse(rawHomeCity)
          : rawHomeCity ?? {};

      return homeCity?.referral_code ?? null;
    } catch (e) {
      console.error("Invalid JSON in home_city:", e);
      return null;
    }
  }, [citiesData?.home_city]);

  const referralLink = referralCode
    ? `https://app.mapmypay.com/registration?ref=${referralCode}`
    : "https://app.mapmypay.com/registration";

  // if only 1 compare city → use 6
  // if more than 1 → use 4
  const colSize = isBelow1280 ? 6 : compareCount === 1 ? 6 : 4;
  useEffect(() => {
    if (token) {
      dispatch(sharedComparison(token))
        .then((res) => {})
        .catch((err) => {});
    } else {
    }
  }, [token, dispatch]);

  const handleMouseDown = (e) => {
    if (!scrollRef.current) return;

    setIsDragging(true);
    setStartX(e.pageX - scrollRef.current.offsetLeft);
    setScrollLeft(scrollRef.current.scrollLeft);
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - scrollRef.current.offsetLeft;
    const walk = (x - startX) * 1.5; // scroll speed multiplier
    scrollRef.current.scrollLeft = scrollLeft - walk;
  };

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;

    const updateArrows = () => {
      const atStart = el.scrollLeft <= 20;
      const atEnd =
        Math.abs(el.scrollLeft + el.clientWidth - el.scrollWidth) <= 20;

      setShowLeftArrow(!atStart);
      setShowRightArrow(!atEnd);
    };

    updateArrows();

    el.addEventListener("scroll", updateArrows);
    window.addEventListener("resize", updateArrows);

    return () => {
      el.removeEventListener("scroll", updateArrows);
      window.removeEventListener("resize", updateArrows);
    };
  }, [homeCity, compareCities]);
  // const scrollToLeft = () => {
  //   if (!scrollRef.current) return;

  //   const container = scrollRef.current;
  //   const visibleWidth = container.clientWidth;
  //   const scrollAmount = -visibleWidth * 0.5;

  //   container.scrollBy({
  //     left: scrollAmount,
  //     behavior: "smooth",
  //   });
  // };
  const scrollToLeft = () => {
    if (!scrollRef.current) return;

    const container = scrollRef.current;
    const firstCard = container.querySelector(".compare-city");

    if (!firstCard) return;

    const cardWidth = firstCard.offsetWidth;
    const gap = 16;

    container.scrollBy({
      left: -(cardWidth + gap),
      behavior: "smooth",
    });
  };

  // const scrollToRight = () => {
  //   if (!scrollRef.current) return;

  //   const container = scrollRef.current;
  //   const visibleWidth = container.clientWidth;
  //   const scrollAmount = visibleWidth * 0.4;

  //   container.scrollBy({
  //     left: scrollAmount,
  //     behavior: "smooth",
  //   });
  // };
  const scrollToRight = () => {
    if (!scrollRef.current) return;

    const container = scrollRef.current;
    const firstCard = container.querySelector(".compare-city");

    if (!firstCard) return;

    const cardWidth = firstCard.offsetWidth;
    const gap = 15; // adjust if you have margin/gap between cards

    container.scrollBy({
      left: cardWidth + gap,
      behavior: "smooth",
    });
  };
  useEffect(() => {
    const handleResize = () => {
      setIsBelow1280(window.innerWidth <= 1280);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const pieChartBaseOptions = useMemo(
    () => ({
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: { display: false },
        tooltip: { enabled: true },
      },
    }),
    [],
  );
  const normalizePieLabel = (label) => {
    if (label === "Mortgage" || label === "Rent") return "Housing";
    return label;
  };
  // const pieDataOrder = ["Income Taxes", "Housing", "Leftover"];
  // const renderPieChart = useCallback(
  //   (cityData) => {
  //     if (!cityData?.pie_data) return null;

  //     const orderedPieData = [...cityData.pie_data].sort((a, b) => {
  //       return (
  //         pieDataOrder.indexOf(normalizePieLabel(a.label)) -
  //         pieDataOrder.indexOf(normalizePieLabel(b.label))
  //       );
  //     });

  //     const pieData = {
  //       labels: cityData.pie_data.map((item) => item.label),
  //       datasets: [
  //         {
  //           data: cityData.pie_data.map((item) => item.value),
  //           backgroundColor: cityData.pie_data.map((item) => item.color),
  //           borderWidth: 0,
  //         },
  //       ],
  //     };

  //     const options = {
  //       ...pieChartBaseOptions,
  //     };

  //     return (
  //       <div className="money-month">
  //         <div className="monthly-box-graph">
  //           <div className="text-end">
  //             <Pie data={pieData} options={options} />
  //           </div>
  //           <div className="p-0">
  //             <div className="money-month-legend">
  //               {orderedPieData.map((item, index) => {
  //                 let price = "";
  //                 if (item.label === "Rent" || item.label === "Mortgage") {
  //                   price = Number(cityData.mortgage || 0)
  //                     .toFixed(0)
  //                     .toLocaleString("en-US");
  //                 } else if (item.label === "Income Taxes") {
  //                   price = Number(cityData.taxes || 0)
  //                     .toFixed(0)
  //                     .toLocaleString("en-IN");
  //                 } else if (item.label === "Leftover") {
  //                   price = Number(cityData.left_over || 0)
  //                     .toFixed(0)
  //                     .toLocaleString("en-US");
  //                 }

  //                 if (!price) return null;

  //                 return (
  //                   <div className="item col-12" key={index}>
  //                     <span className="key-small">
  //                       <span
  //                         className="key"
  //                         style={{ backgroundColor: item.color }}
  //                       ></span>
  //                       <span className="small">{item.label}</span>
  //                     </span>
  //                     <span className="percentage-price text-end">
  //                       <span className="percentage">
  //                         {item.percentage || item.text}
  //                       </span>

  //                       <span className="price">${price} /month</span>
  //                     </span>
  //                   </div>
  //                 );
  //               })}
  //             </div>
  //           </div>
  //         </div>

  //         {cityData.net_diff?.value && (
  //           <div className="content">
  //             <div className="contentwrap">
  //               <div className="icon">
  //                 <img src="/img/zik-zake-line.svg" alt="zikzake" />
  //                 {/* <img src={ZIkZakeIcon} alt="icon" /> */}
  //               </div>
  //               <div className="gross-salary">
  //                 <div className="gross-title">Net Leftover Income</div>
  //                 <div className="gross-price">
  //                   $
  //                   {Number(cityData.left_over || 0)
  //                     .toFixed(0)
  //                     .toLocaleString("en-US")}
  //                   <span className="price">
  //                     {/* {selectedDuration?.label === "Monthly"
  //                       ? "/month"
  //                       : "/year"} */}
  //                     /month
  //                   </span>
  //                 </div>
  //               </div>
  //             </div>
  //           </div>
  //         )}
  //       </div>
  //     );
  //   },
  //   [pieChartBaseOptions, pieDataOrder],
  // );

  const renderPieChart = useCallback(
    (cityData) => {
      if (!cityData?.pie_data) return null;

      const pieDataOrder = ["Income Taxes", "Housing", "Leftover"];

      const orderedPieData = [...cityData.pie_data].sort((a, b) => {
        return (
          pieDataOrder.indexOf(normalizePieLabel(a.label)) -
          pieDataOrder.indexOf(normalizePieLabel(b.label))
        );
      });

      const pieData = {
        labels: cityData.pie_data.map((item) => item.label),
        datasets: [
          {
            data: cityData.pie_data.map((item) => item.value),
            backgroundColor: cityData.pie_data.map((item) => item.color),
            borderWidth: 0,
          },
        ],
      };

      const options = {
        ...pieChartBaseOptions,
      };

      return (
        <div className="money-month">
          <div className="monthly-box-graph">
            <div className="text-end">
              <Pie data={pieData} options={options} />
            </div>
            <div className="p-0">
              <div className="money-month-legend">
                {orderedPieData.map((item, index) => {
                  let price = "";
                  if (item.label === "Rent" || item.label === "Mortgage") {
                    price = Number(cityData.mortgage || 0)
                      .toFixed(0)
                      .toLocaleString("en-US");
                  } else if (item.label === "Income Taxes") {
                    price = Number(cityData.taxes || 0)
                      .toFixed(0)
                      .toLocaleString("en-IN");
                  } else if (item.label === "Leftover") {
                    price = Number(cityData.left_over || 0)
                      .toFixed(0)
                      .toLocaleString("en-US");
                  }

                  if (!price) return null;

                  return (
                    <div className="item col-12" key={index}>
                      <span className="key-small">
                        <span
                          className="key"
                          style={{ backgroundColor: item.color }}
                        ></span>
                        <span className="small">{item.label}</span>
                      </span>
                      <span className="percentage-price text-end">
                        <span className="percentage">
                          {item.percentage || item.text}
                        </span>

                        <span className="price">${price} /month</span>
                      </span>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>

          {cityData.net_diff?.value && (
            <div className="content">
              <div className="contentwrap">
                <div className="icon">
                  <img src="/img/zik-zake-line.svg" alt="zikzake" />
                  {/* <img src={ZIkZakeIcon} alt="icon" /> */}
                </div>
                <div className="gross-salary">
                  <div className="gross-title">Net Leftover Income</div>
                  <div className="gross-price">
                    $
                    {Number(cityData.left_over || 0)
                      .toFixed(0)
                      .toLocaleString("en-US")}
                    <span className="price">
                      {/* {selectedDuration?.label === "Monthly"
                        ? "/month"
                        : "/year"} */}
                      /month
                    </span>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      );
    },
    [pieChartBaseOptions], // ✅ removed pieDataOrder
  );

  const handleComparision = () => {
    window.open(referralLink, "_blank", "noopener,noreferrer");
  };

  if (isLoading) {
    return (
      <Container className="vh-100 d-flex justify-content-center align-items-center">
        <div className="text-center">
          <div className="spinner-border text-primary mb-3" role="status" />
          <h5>Loading comparison data...</h5>
        </div>
      </Container>
    );
  }

  if (isError) {
    return (
      <Container className="vh-100 d-flex justify-content-center align-items-center">
        <div className="text-center">
          <h4 className="mb-2">Share not found</h4>
          <p className="text-muted">
            The shared comparison link may be invalid or expired.
          </p>
        </div>
      </Container>
    );
  }

  const data = sharedComparisonItems?.data;

  if (!data) {
    return (
      <Container className="vh-100 d-flex justify-content-center align-items-center">
        <div className="text-center">
          <h4 className="mb-2">No Data Available</h4>
          <p className="text-muted">
            There is no comparison data to display at the moment.
          </p>
        </div>
      </Container>
    );
  }

  return (
    <Container className="py-4">
      <div className="student-loan-content">
        <Card className="p-0">
          <Card.Body>
            <div className="header-banner">
              <div className="logo">
                <img src="/img/logo.svg" alt="logo" />
              </div>
              {/* <h4>Map My Pay</h4> */}
              <p>
                Compare salaries across locations and make informed career
                decisions
              </p>
            </div>
          </Card.Body>
        </Card>
        <div className="city-content with-new mt-2">
          {/* City Comparison with Charts */}
          <Card className="city-comparison-content mb-0">
            <Card.Body>
              <>
                <div className="comparison-wrapper position-relative">
                  {/* Left Arrow */}
                  {showLeftArrow && (
                    <button
                      className="slider-arrow left"
                      onClick={scrollToLeft}
                      alt="left-arrow"
                    >
                      {/* <LeftIcon /> */}
                      <img src="/img/left-aero.svg" alt="Left" />
                    </button>
                  )}

                  {showRightArrow && (
                    <button
                      className="slider-arrow right"
                      onClick={scrollToRight}
                      alt="right-arrow"
                    >
                      {/* <RightIcon /> */}
                      <img src="/img/right-aero.svg" alt="right" />
                    </button>
                  )}

                  <Row
                    className="g-3 compare-city-row"
                    ref={scrollRef}
                    onMouseDown={handleMouseDown}
                    onMouseLeave={handleMouseLeave}
                    onMouseUp={handleMouseUp}
                    onMouseMove={handleMouseMove}
                  >
                    {homeCity && (
                      <Col md={colSize} className="compare-city col-6">
                        <Card className="city-all-content">
                          <Card.Body className="p-0">
                            <div className="city-details">
                              <div className="title-btn">
                                <div className="inner-sub-sub-title pb-0">
                                  <div className="title-subtitle pb-0">
                                    <div className="inner-sub-title pb-0 cursor-pointer">
                                      {`${homeCity.city}, ${homeCity.state}`}
                                    </div>
                                    <div className="inner-sub-subtitle">
                                      {`${homeCity.role}`}
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="crimerate-hospitals">
                                <div className="hospitals">
                                  <img
                                    src="/img/hospitals-icon.svg"
                                    alt="hospital"
                                  />
                                  <span className="hospital">
                                    {homeCity?.hospital_count}
                                  </span>
                                </div>
                                <div
                                  className="crimerate"
                                  style={{
                                    backgroundColor:
                                      homeCity?.color_code?.toLowerCase() ===
                                      "yellow"
                                        ? "#f09d08"
                                        : homeCity?.color_code?.toLowerCase() ||
                                          "#000000",
                                  }}
                                  // style={{
                                  //   backgroundColor:
                                  //     homeCity?.color_code.toLowerCase() ===
                                  //     "yellow"
                                  //       ? "#f09d08"
                                  //       : homeCity?.color_code.toLowerCase() ||
                                  //         "#000000",
                                  // }}
                                >
                                  <img src="/img/crime-icon.svg" alt="crime" />
                                  <span className="crime ">
                                    {homeCity?.app_display}
                                  </span>
                                </div>
                              </div>

                              <div className="city-sub-details">
                                <div className="pricing-col">
                                  <div className="contentwrap">
                                    <div className="icon">$</div>
                                    <div className="gross-salary">
                                      <div className="gross-title">
                                        Gross Average Salary
                                      </div>

                                      <div className="gross-price">
                                        $
                                        {Number(
                                          Number(
                                            homeCity?.median_salary || 0,
                                          ).toFixed(0),
                                        ).toLocaleString("en-US")}
                                        <span className="text-secondary">
                                          /month
                                        </span>
                                      </div>

                                      <div className="gross-hour">
                                        $
                                        {Number(
                                          Number(
                                            homeCity?.hourly_gross_salary || 0,
                                          ).toFixed(0),
                                        ).toLocaleString("en-US")}
                                        /hour
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                {renderPieChart(homeCity)}
                              </div>
                            </div>
                          </Card.Body>
                        </Card>
                      </Col>
                    )}

                    {compareCities.map((city) => (
                      <Col
                        md={colSize}
                        key={city.id}
                        className="compare-city col-6"
                      >
                        <Card className="city-all-content">
                          <Card.Body className="p-0">
                            <div className="city-details">
                              <div className="title-btn with-remove">
                                <div className="inner-sub-sub-title pb-0">
                                  <div className="title-subtitle pb-0">
                                    <div className="inner-sub-title pb-0 cursor-pointer">{`${city.city}, ${city.state}`}</div>
                                  </div>
                                  <div className="inner-sub-subtitle">
                                    {`${city.role}`}
                                  </div>
                                </div>
                              </div>

                              <div className="crimerate-hospitals">
                                <div className="hospitals">
                                  <img
                                    src="/img/hospitals-icon.svg"
                                    alt="hospital"
                                  />
                                  <span className="hospital">
                                    {city?.hospital_count}
                                  </span>
                                </div>
                                <div
                                  className="crimerate"
                                  style={{
                                    backgroundColor:
                                      city?.color_code?.toLowerCase() ===
                                      "yellow"
                                        ? "#f09d08"
                                        : city?.color_code?.toLowerCase() ||
                                          "#000000",
                                  }}
                                  // style={{
                                  //   backgroundColor:
                                  //     city?.color_code.toLowerCase() ===
                                  //     "yellow"
                                  //       ? "#f09d08"
                                  //       : city?.color_code.toLowerCase() ||
                                  //         "#000000",
                                  // }}
                                >
                                  <img src="/img/crime-icon.svg" alt="crime" />
                                  <span className="crime">
                                    {city?.app_display}
                                  </span>
                                </div>
                              </div>
                              <div className="city-sub-details ">
                                <div className="pricing-col">
                                  <div className="contentwrap">
                                    <div className="icon">$</div>
                                    <div className="gross-salary">
                                      <div className="gross-title">
                                        Gross Average Salary
                                      </div>

                                      <div className="gross-price">
                                        $
                                        {Number(
                                          Number(
                                            city.median_salary || 0,
                                          ).toFixed(0),
                                        ).toLocaleString("en-US")}
                                        <span className="text-secondary">
                                          /month
                                        </span>
                                      </div>

                                      <div className="gross-hour">
                                        $
                                        {Number(
                                          Number(
                                            city.hourly_gross_salary || 0,
                                          ).toFixed(0),
                                        ).toLocaleString("en-US")}
                                        /hour
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                {renderPieChart(city)}
                              </div>
                            </div>
                          </Card.Body>
                        </Card>
                      </Col>
                    ))}
                  </Row>
                </div>
              </>
            </Card.Body>
          </Card>
        </div>
        <Card className="snowball-card">
          <CardBody>
            <div className="snowball-card-content">
              <div className="left-section">
                <div className="inner-sub-sub-title">
                  <h4 className="inner-sub-title">
                    Haven't Downloaded MapMyPay Yet?
                  </h4>
                  <p>
                    Download now to compare salaries, find the best locations,
                    <br />
                    and make smarter career decisions!
                  </p>
                </div>

                <div className="d-flex gap-3 flexwrap">
                  <a
                    href="https://apps.apple.com/us/app/map-my-pay/id6747190135"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Download on App Store"
                  >
                    <img src="/img/app-icon.svg" alt="apple-icon" />
                  </a>

                  <a
                    href="https://play.google.com/store/apps/details?id=com.mapmypay"
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label="Get it on Google Play"
                  >
                    <img src="/img/android-icon.svg" alt="android-icon" />
                  </a>
                </div>
              </div>
              <div className="qr-floating-wrapper">
                <div className="qr-watercolor-box">
                  <QRCodeCanvas
                    value={referralLink}
                    bgColor="#ffffff"
                    fgColor="#000000"
                    level="H"
                    includeMargin={true}
                  />
                </div>

              <div className="qr-caption mt-2">
                Join MapMyPay by<br /> scanning my QR code.{" "}
              </div>
              </div>
            </div>
            <div className="buttons main-btn">
              <Button
                variant="primary"
                className="live-cheaper-btn"
                onClick={handleComparision}
              >
                Compare more locations
              </Button>
            </div>
            <hr />

            <div className="copyright text-center">
              © {new Date().getFullYear()} MapMyPay. All rights reserved.
            </div>
          </CardBody>
        </Card>
      </div>
    </Container>
  );
};

export default CityComparison;
